import { Card, CollapsibleCard } from "abs-ui-components";
import "./AbsCard.scss";
import boat from "../../images/boat.png";
import vector from "../../images/vector.png";
import file from "../../images/file.png";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
const AbsCard = (props) => {
	if (props.cardData) {
	}
	const {
		cardClr,
		totalText,
		isEnrollActiveCard,
		totalEnrolledVesselsCount,
		totalActiveVesselsCount,
		totalCount,
		cardHeader,
		cardDescription,
		cardType,
		iconText,
		navigationURL,
	} = props.cardData ? props.cardData : {};

	const isChartCard = props.isChartCard;
	const navigate = useNavigate();
	let cardData = "";

	// useEffect(() => {
	if (isChartCard) {
		cardData = props.chartData;
	} else {
		cardData = (
			<div
				className={
					cardType === "dcs" ||
					cardType === "eumrv" ||
					cardType === "ukmrv"
						? "child-card-container"
						: "dashboard-card-container"
				}
				onClick={
					navigationURL ? () => navigate(`${navigationURL}`) : null
				}
			>
				<div className="d-flex justify-content-between">
					<div
						className="d-card-container d-flex justify-content-center align-items-center"
						style={{ backgroundColor: `${cardClr}` }}
					>
						{iconText ? (
							<span
								style={{
									fontWeight: 800,
									fontFamily: "Roboto",
									fontSize: "23px",
								}}
							>
								{iconText}
							</span>
						) : (
							<img
								src={
									cardType === "enroll_vessel"
										? boat
										: cardType === "reports"
										? file
										: cardType === "portcodes"
										? vector
										: null
								}
							/>
						)}
					</div>
					<div>
						<div className="total-text">{totalText}</div>
						<div className="total-number">
							{props.loader ? (
								<CircularProgress size={20} />
							) : isEnrollActiveCard ? (
								`${totalEnrolledVesselsCount}`
							) : totalCount !== undefined ? (
								totalCount
							) : (
								0
							)}
						</div>
					</div>
				</div>
				<div className="mt-3">
					{/* <div className="dashboard-card-header">
					{isEnrollActiveCard ? "Enrolled Vessels" : cardHeader}
				</div> */}
					<div className="dashboard-card-description">
						{cardDescription}
					</div>
				</div>
			</div>
		);
	}
	// return <Card className="mr-5 pt-2 pb-2" data={{ body: cardData }} />;
	return (
		<CollapsibleCard
			title={{
				content: isChartCard ? "Child Reports" : cardHeader,
				className: "collapsCardHeader",
			}}
			isOpen={true}
		>
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				{cardData}
			</div>
		</CollapsibleCard>
	);
};

export default AbsCard;
